(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var App = function () {
    function App() {
        _classCallCheck(this, App);

        console.info("App Initialized");
    }

    _createClass(App, [{
        key: "test",
        value: function test() {
            return "test from modules/app.js class";
        }
    }, {
        key: "onScroll",
        value: function onScroll(event) {

            var scrollPos = $(document).scrollTop();

            if (scrollPos == 0) {
                $(".nav-item").removeClass("active");
                $(".nav-item").eq(0).addClass("active");
            }
        }
    }, {
        key: "events",
        value: function events() {
            $("[data-trigger]").on("click", function () {
                var trigger_id = $(this).attr('data-trigger');
                $(trigger_id).toggleClass("show");
                $('body').toggleClass("offcanvas-active");
            });

            // close button 
            $(".btn-close").click(function (e) {
                $(".navbar-collapse").removeClass("show");
                $("body").removeClass("offcanvas-active");
            });

            // fancybox??
            // $(".section-gallery a").on("click", function(event){
            //     event.preventDefault();
            //     console.log("fancybox??");
            // });

            // scroll top
            $(".icon-scroll-top").on("click", function (event) {
                event.preventDefault();
                $("html, body").animate({ scrollTop: 0 }, 250);
                return false;
            });
            // scroll down
            $(".icon-scroll-down").on("click", function (event) {
                event.preventDefault();
                var sectionSliderHeight = $(".section-slider").innerHeight();

                $("html, body").animate({ scrollTop: sectionSliderHeight }, 250);
                return false;
            });

            // slick
            $('.slick-slider').slick({
                dots: true,
                speed: 500
            });

            $('.partners-slick-slider').slick({
                autoplay: true,
                autoplaySpeed: 2000,
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: true,
                dots: false,
                arrows: false,
                speed: 500,
                responsive: [{
                    breakpoint: 992,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        slidesToShow: 2
                    }
                }, {
                    breakpoint: 576,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        slidesToShow: 1
                    }
                }]
            });

            // scroll to
            $('.scroll a').on("click", function (event) {
                event.preventDefault();

                $(".nav-item").removeClass("active");
                $(this).parent(".nav-item").addClass("active");

                // if mobile - hide menu
                $(".btn-close").click();

                var dest = $(this).attr("href");

                if (!$("body").hasClass("homepage")) {
                    window.location.href = base_url + dest;
                    return;
                }

                $("html, body").animate({
                    'scrollTop': $(dest).offset().top
                }, 750);
            });
        }
    }]);

    return App;
}();

exports.default = App;

},{}],2:[function(require,module,exports){
"use strict";

var _app = require("./modules/app.js");

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var app = new _app2.default();
// console.log(app.test());


(function () {

    console.log("jq version " + jQuery().jquery);

    app.test();
    app.events();

    if ($(".navbar").hasClass("homepage")) {
        $(document).on("scroll", app.onScroll);
    }
})();

},{"./modules/app.js":1}]},{},[2]);
